import { ApplicationActivity } from "../types";
import { combinedRoles } from "../constants";
import { getFullName } from "shared/utils/get-full-name";

const titles = {
  identity_verification_rerun_requested: "Identity re-verification request",
  identity_verification_rerun_completed: "Identity re-verification",
  identity_verification_rerun_canceled: "Identity re-verification request",
  identity_verification_bypass_requested:
    "Request to bypass identity verification",
  identity_verification_bypass_approved: "Identity verification bypass",
  identity_verification_bypass_declined:
    "Request to bypass identity verification"
} as const;

const actions = {
  identity_verification_rerun_requested: "was sent",
  identity_verification_rerun_completed: "was completed",
  identity_verification_rerun_canceled: "was canceled",
  identity_verification_bypass_requested: "was sent",
  identity_verification_bypass_approved: "was approved",
  identity_verification_bypass_declined: "was declined"
} as const;

// "to" for a request the applicant still has to act on, "for" once the outcome
// is decided by the partner.
const contactPrepositions = {
  identity_verification_rerun_requested: "To",
  identity_verification_rerun_completed: undefined,
  identity_verification_rerun_canceled: "For",
  identity_verification_bypass_requested: "By",
  identity_verification_bypass_approved: "For",
  identity_verification_bypass_declined: "For"
} as const;

type IdentityVerificationRerunActivityType = keyof typeof titles;

export const IdentityVerificationRerun = ({
  activityItem
}: {
  activityItem: ApplicationActivity;
}) => {
  const activityType =
    activityItem.activity_type as IdentityVerificationRerunActivityType;
  const contact = activityItem.details?.contact;
  const contactPreposition = contactPrepositions[activityType];
  const showAuthor =
    activityType !== "identity_verification_bypass_requested" &&
    Boolean(activityItem.author?.name);

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        {titles[activityType]}{" "}
        <span className="font-normal">
          {actions[activityType]}
          {showAuthor ? ` by ${activityItem.author?.name}` : null}
        </span>
      </p>
      {contact && contactPreposition ? (
        <p className="text-sm font-normal text-content-400">
          {contactPreposition}{" "}
          {getFullName({
            firstName: contact.first_name,
            lastName: contact.last_name,
            middleName: contact.middle_name,
            short: true
          })}{" "}
          ({contact.role ? combinedRoles[contact.role] : "-"})
        </p>
      ) : null}
      {activityType === "identity_verification_bypass_declined" &&
      activityItem.details?.note ? (
        <p className="text-sm font-normal text-content-400">
          Note: &ldquo;{activityItem.details.note}&rdquo;
        </p>
      ) : null}
    </div>
  );
};
